var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:{
    error: _vm.paxError(_vm.field),
    add_pass_field: true
  },attrs:{"xs4":""}},[_c('v-layout',{attrs:{"column":""}},[_c('div',{staticClass:"head"},[_vm._v(_vm._s(_vm.type))]),_c('div',{staticClass:"subhead"},[_vm._v(_vm._s(_vm.desc))]),_c('v-select',{attrs:{"items":_vm.passengerValueRange(_vm.min, _vm.max),"outlined":"","dense":""},on:{"change":function($event){return _vm.validatePax(_vm.field, _vm.min, _vm.max)}},model:{value:(_vm.thisField),callback:function ($$v) {_vm.thisField=$$v},expression:"thisField"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }